<template>
  <div id="contenedor-entes-fiscalizadores-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoEnteFiscalizador="registrarNuevoEnteFiscalizador"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoEntesFiscalizadores="getEntesFiscalizadores"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoEnteFiscalizador"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <registrar-ente-fiscalizador
      v-if="mostrarVentanaRegistrarNuevoEnteFiscalizador"
      v-on:cerrar="cerrarRegistrarEnteFiscalizador"
      >
      </registrar-ente-fiscalizador>
    </v-dialog>
    <v-dialog
    persistent
    v-if="esteEnteFiscalizador"
      v-model="mostrarVentanaEditarEnteFiscalizador"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <editar-ente-fiscalizador
        :enteFiscalizadorEditar="esteEnteFiscalizador"
        v-on:cerrar="cerrarEditarEnteFiscalizador">
      </editar-ente-fiscalizador>
    </v-dialog>
    <v-dialog
    v-if="esteEnteFiscalizador"
      v-model="mostrarVentanaEliminarEnteFiscalizador"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-ente-fiscalizador
      :enteFiscalizadorEliminar ="esteEnteFiscalizador"
      v-on:cerrar="cerrarEliminarEnteFiscalizador">
      </eliminar-ente-fiscalizador>
    </v-dialog>
  </div>
</template>

<script>
import ENTES_FISCALIZADORES from '@/graphql/querys/administracion/catalogos/entesfiscalizadores/entesFiscalizadores.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarEnteFiscalizador from '@/components/administracion/configuracion/catalogos/entesfiscalizadores/Nuevo.vue';
import EditarEnteFiscalizador from '@/components/administracion/configuracion/catalogos/entesfiscalizadores/Editar.vue';
import EliminarEnteFiscalizador from '@/components/administracion/configuracion/catalogos/entesfiscalizadores/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'EntesFiscalizadoresDefault',
  components: {
    TituloToolBar,
    RegistrarEnteFiscalizador,
    EditarEnteFiscalizador,
    EliminarEnteFiscalizador,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoEnteFiscalizador: false,
      mostrarVentanaEditarEnteFiscalizador: false,
      mostrarVentanaEliminarEnteFiscalizador: false,
      esteEnteFiscalizador: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    entesFiscalizadores: {
      query: ENTES_FISCALIZADORES,
    },
  },
  mounted() {
    eventBus.$on('editar-ente-fiscalizador', (enteFiscalizador) => {
      this.esteEnteFiscalizador = enteFiscalizador;
      this.mostrarVentanaEditarEnteFiscalizador = true;
    });
    eventBus.$on('eliminar-ente-fiscalizador', (enteFiscalizador) => {
      this.esteEnteFiscalizador = enteFiscalizador;
      this.mostrarVentanaEliminarEnteFiscalizador = true;
    });
  },
  methods: {
    registrarNuevoEnteFiscalizador() {
      this.mostrarVentanaRegistrarNuevoEnteFiscalizador = true;
    },
    cerrarRegistrarEnteFiscalizador() {
      this.mostrarVentanaRegistrarNuevoEnteFiscalizador = false;
    },
    cerrarEditarEnteFiscalizador() {
      this.mostrarVentanaEditarEnteFiscalizador = false;
      this.esteEnteFiscalizador = null;
    },
    cerrarEliminarEnteFiscalizador() {
      this.mostrarVentanaEliminarEnteFiscalizador = false;
      this.esteEnteFiscalizador = null;
    },
  },
  computed: {
    getEntesFiscalizadores() {
      if (!this.entesFiscalizadores) return [];
      return this.entesFiscalizadores
      // Filtrar por Texto de Busqueda
        .filter((ente) => {
          if (!this.filtros.buscarTexto) return ente;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(ente.descripcion);
          return (
            expt.test(nombre)
          || expt.test(ente.descripcion)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
